<script setup lang="ts">
import { instanceOfTrackItDataTypeBooleanDto, TrackItDataTypeDto } from '@/api/generator';
import CommentInlineDialog from '@/components/comments/CommentInlineDialog.vue';
import KeyValueTable from '@/components/KeyValueTable/KeyValueTable.vue';
import { computed } from 'vue';

const props = defineProps<{
  title: string;
  dataPoints: TrackItDataTypeDto[];
}>();

// Boolean has no unit; Double/Long share the same value/unit shape.
function formatValue(dataType: TrackItDataTypeDto): string {
  if (instanceOfTrackItDataTypeBooleanDto(dataType)) {
    return dataType.value == null ? '' : String(dataType.value);
  }
  return dataType.value == null ? '' : `${dataType.value} ${dataType.unit ?? ''}`.trim();
}

const rows = computed(() =>
  props.dataPoints.map((dataPoint) => ({
    label: dataPoint.name ?? '',
    value: formatValue(dataPoint),
    definition: dataPoint.definition,
    dataPoint,
  })),
);
</script>

<template>
  <div>
    <h5>{{ title }}</h5>
    <KeyValueTable :rows="rows">
      <template #label="{ row }">
        {{ row.label }}
        <div v-if="row.definition" class="text-caption text-medium-emphasis">
          {{ row.definition }}
        </div>
      </template>

      <template #value="{ row }">
        <div class="d-flex align-center justify-end ga-2">
          {{ row.value }}
          <CommentInlineDialog
            :entity="row.dataPoint"
            entityWithCommentType="EvaluationResultOrDataPoint"
            readonly
            :showCountAlways="false"
          />
        </div>
      </template>
    </KeyValueTable>
  </div>
</template>
